// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__gnZvv","rootSmall":"AddTileButton_rootSmall__3_BwN"};